import type { DataGridColumnSettings, JsonDataItem, OdinDataFilter } from '@myosh/odin-components';
import i18n from '../../i18n';

export const globalSearchColumns: Array<DataGridColumnSettings> = [
  {
    id: 1,
    field: 'descriptionText',
    valuePath: 'description',
    title: i18n.t('description'),
    visible: true,
    searchType: 'TextSearch',
    disableSort: true,
  },
  {
    id: 2,
    field: 'moduleSearchText',
    valuePath: 'module.caption',
    title: i18n.t('module'),
    visible: true,
    searchType: 'TextSearch',
    disableSort: true,
  },
  {
    id: 3,
    field: 'moduleFormSearchText',
    valuePath: 'form.caption',
    title: i18n.t('module-form'),
    visible: true,
    searchType: 'TextSearch',
    disableSort: true,
  },
  {
    id: 4,
    field: 'docNumberText',
    valuePath: 'docNo',
    title: i18n.t('doc-no'),
    visible: true,
    searchType: 'TextSearch',
    disableSort: true,
  },
  {
    id: 5,
    field: 'createdDateRange',
    valuePath: 'creationDate',
    title: i18n.t('creation-date'),
    visible: true,
    type: 2,
    searchType: 'DateRange',
    disableSort: true,
  },
  {
    id: 6,
    field: 'lastChangedDateRange',
    valuePath: 'lastChange',
    title: i18n.t('last-changed'),
    visible: true,
    type: 2,
    searchType: 'DateRange',
    disableSort: true,
  },
  {
    id: 101,
    title: i18n.t('id'),
    field: 'id',
    type: 1,
    visible: false,
    isIdField: true,
    searchType: 'Integer',
    disableSort: true,
  },
];

export function transformFilters(input: Record<string, OdinDataFilter>) {
  const filters: JsonDataItem = {};

  for (const [key, filter] of Object.entries(input)) {
    const value = filter?.value;

    if (!value) continue;

    if (Array.isArray(value)) {
      const from = value[0] ? (value[0] as Date).toISOString() : '';
      const to = value[1] ? (value[1] as Date).toISOString() : '';

      if (from || to) {
        filters[key] = { from, to };
      }
    } else if (typeof value === 'string' && value.trim() !== '') {
      filters[key] = value;
    }
  }

  return filters;
}
